module.exports = __webpack_public_path__ + "static/media/ND-1.5-MX5.0749f87e.jpg";